import smoothScroll from '../utils/smoothScroll';

const toTopLink = document.querySelector('#scroll-top');

const addClickEvent = () => {
  toTopLink.addEventListener('click', () => {
    smoothScroll(0);
  });
};

(() => {
  if (toTopLink) {
    addClickEvent();
  }
})();
